module.exports = __webpack_public_path__ + "ba8832cbc771bd37c21553b1e5a464cc.fbx";